import React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';
import { FourOhFourError } from '@sm/webassets';
import PageLoading from './components/PageLoading';

const Account = loadable(() => import(/* webpackChunkName: 'coreweb-account' */ './pages/account'), {
  fallback: <PageLoading />,
});

const Analysis = loadable(() => import(/* webpackChunkName: 'coreweb-analysis-base' */ './pages/analysis'), {
  fallback: <PageLoading />,
});

const PublishedDashboard = loadable(
  () => import(/* webpackChunkName: 'coreweb-dashboards' */ './pages/PublishedDashboard'),
  {
    fallback: <PageLoading />,
  }
);

const InstantResults = loadable(
  () => import(/* webpackChunkName: 'coreweb-instant-results' */ './pages/InstantResults'),
  {
    fallback: <PageLoading />,
  }
);

const LiveResults = loadable(() => import(/* webpackChunkName: 'coreweb-live-results' */ './pages/LiveResults'), {
  fallback: <PageLoading />,
});

const CrosstabReports = loadable(
  () => import(/* webpackChunkName: 'coreweb-crosstab-reports' */ './pages/CrosstabReports'),
  {
    fallback: <PageLoading />,
  }
);

const AudienceSelectSurvey = loadable(
  () => import(/* webpackChunkName: 'coreweb-select-survey' */ './pages/audience/SelectSurvey'),
  {
    fallback: <PageLoading />,
  }
);

const AudienceStatus = loadable(
  () => import(/* webpackChunkName: 'coreweb-audience-status' */ './pages/audience/Status'),
  {
    fallback: <PageLoading />,
  }
);

const AudienceCalculator = loadable(
  () => import(/* webpackChunkName: 'coreweb-audience-calculator' */ './pages/audience/Calculator'),
  {
    fallback: <PageLoading />,
  }
);

const Profile = loadable(() => import(/* webpackChunkName: 'coreweb-profile' */ './pages/profile'), {
  fallback: <PageLoading />,
});

const CreateSurvey = loadable(() => import(/* webpackChunkName: 'coreweb-create-survey' */ './pages/CreateSurvey'), {
  fallback: <PageLoading />,
});

const Solutions = loadable(() => import(/* webpackChunkName: 'coreweb-solutions' */ './pages/solutions'), {
  fallback: <PageLoading />,
});

const Team = loadable(
  () =>
    import(
      /* webpackChunkName: 'coreweb-team' */
      './pages/Team'
    ),
  {
    fallback: <PageLoading />,
  }
);

const User = loadable(() => import(/* webpackChunkName: 'coreweb-user' */ './pages/User'), {
  fallback: <PageLoading />,
});

const Billing = loadable(() => import(/* webpackChunkName: 'coreweb-billing' */ './pages/Billing'), {
  fallback: <PageLoading />,
});

const SurveysCore = loadable(() => import(/* webpackChunkName: 'coreweb-surveys-core' */ './pages/SurveysCore'), {
  fallback: <PageLoading />,
});

const SeatRequest = loadable(
  () => import(/* webpackChunkName: 'coreweb-seat-request' */ './pages/Team/ManageUsers/SeatRequest'),
  {
    fallback: <PageLoading />,
  }
);

const CoreCheckout = loadable(() => import(/* webpackChunkName: 'coreweb-checkout' */ './pages/Checkout'), {
  fallback: <PageLoading />,
});

const App = () => {
  return (
    <Switch>
      <Route path="/:page(summary|stories)/:encryptedSid">
        <SurveysCore />
      </Route>
      <Route path="/analyze" component={Analysis} />
      <Route path="/dashboards/:dashboardId" component={PublishedDashboard} />
      <Route path="/live/results" component={LiveResults} />
      <Route path="/results/:sharedViewKey/instant" component={InstantResults} />
      <Route path="/crosstabs" component={CrosstabReports} />
      <Route path="/collect/audience/select_survey" component={AudienceSelectSurvey} />
      <Route path="/collect/audience/:collectorId/status" component={AudienceStatus} />
      <Route path="/collect/audience/:collectorId/calculator" component={AudienceCalculator} />
      <Route path="/collect/audience/calculator/preview" component={AudienceCalculator} />
      <Route path="/profile" exact component={Profile} />
      <Route path="/profile/:profilePath" component={Profile} />
      <Route path="/create" component={CreateSurvey} />
      <Route path="/solutions" component={Solutions} />
      <Route path="/team/users/seat_request" component={SeatRequest} />
      <Route path="/team" component={Team} />
      <Route path="/user/account/select" component={Account} />
      <Route path="/user" component={User} />
      <Route path="/:page(collect)/add">
        <SurveysCore />
      </Route>
      <Route path="/billing" component={Billing} />
      <Route path="/checkout" component={CoreCheckout} />
      {/* Catch all route */}
      <Route component={FourOhFourError} />
    </Switch>
  );
};

export default App;
